export type Education = {
    degree: string;
    school: string;
    location: string;
    timeframe: string;
    summary: string;
    logo: string;
    graduated: boolean;
};

export const education: Education[] = [
    {
        degree: "Bachelor's of Science, Computer Engineering",
        school: "Bahcesehir University",
        location: "Istanbul, Turkey",
        timeframe: "09/2019 - 06/2021",
        summary: "Focused on software engineering, distributed systems, and cloud computing. Built various full stack projects with React and Node.js.",
        logo: "/logos/bahcesehir.jpg",
        graduated: true
    },
    {
        degree: "Bachelor's of Science, Electrical and Electronics Engineering (Incomplete)",
        school: "Bilkent University",
        location: "Ankara, Turkey",
        timeframe: "09/2016 - 08/2019",
        summary: "Completed foundational courses in mathematics, circuits, and programming before switching focus to computer engineering.",
        logo: "/logos/bilkent.jpg",
        graduated: false
    }
];
